module.exports = __webpack_public_path__ + "assets/vertical.41e6141c.svg";